<div class="adnavem-primary-background-color">
    <button mat-menu-item [matMenuTriggerFor]="adminMenu" class="adnavem-text-color-with-primary-background">
        <span class="fal fa-fw fa-material fa-user-secret adn-menu-icons" aria-hidden="true"></span>&nbsp;Admin
    </button>
    <mat-menu #adminMenu="matMenu">
        <app-menu [menu]="menu" activeItemClass="adn-admin-menu-item-active" itemClass="adn-admin-menu-item"></app-menu>
    </mat-menu>
</div>